module.exports = __webpack_public_path__ + "img/vasco-da-gama.f82cff88.png";